import { render, staticRenderFns } from "./DeadlineSection.vue?vue&type=template&id=20b7bfe7&scoped=true&"
import script from "./DeadlineSection.vue?vue&type=script&lang=js&"
export * from "./DeadlineSection.vue?vue&type=script&lang=js&"
import style0 from "./DeadlineSection.vue?vue&type=style&index=0&id=20b7bfe7&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20b7bfe7",
  null
  
)

export default component.exports